import { ShoeBalletIcon } from './ShoeBalletIcon';

/**
 * author: Michael Irigoyen
 * id B5B68323-60DD-45BF-83FC-892B436D0400
 * name shoe-ballet
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shoe-ballet.svg
 * tags
 * - Sport 
 * - Clothing 
 */
export const SlippersBalletIcon = ShoeBalletIcon;
export default SlippersBalletIcon